module.exports = __webpack_public_path__ + "img/right.5096dfb6.png";